import { DropdownMenuSize } from './DropdownMenu.types';
import { MenuSize } from '@/components';

export const MENU_HEIGHTS = {
  [DropdownMenuSize.S]: '160px',
  [DropdownMenuSize.M]: '200px',
  [DropdownMenuSize.L]: '240px',
};

export const MENU_SIZE = {
  [DropdownMenuSize.S]: MenuSize.S,
  [DropdownMenuSize.M]: MenuSize.M,
  [DropdownMenuSize.L]: MenuSize.L,
};
